import { Progressbar } from 'framework7-react';
import { FC, ReactNode, useMemo } from 'react';

import Card from '../Card/Card';

const GREEN = '#31f207';
const YELLOW = '#fedb41';
const RED = '#e13026';

interface MilestoneProgressProps {
  currentValue: number;
  milestones: number[];
  progressLabel?: ReactNode;
}

const MilestoneProgress: FC<MilestoneProgressProps> = ({
  currentValue,
  milestones,
  progressLabel,
}) => {
  const currentGoal = useMemo(() => {
    return milestones.find((milestone) => currentValue < milestone);
  }, [milestones, currentValue]);

  const percentageOfGoal = currentValue / (currentGoal ?? currentValue);

  const chartColor = useMemo(() => {
    const percentageInt = Math.ceil(percentageOfGoal * 100);

    if (percentageInt === 100) {
      return GREEN;
    }

    if (percentageInt >= 50) {
      return YELLOW;
    }

    return RED;
  }, [percentageOfGoal]);

  return (
    <div>
      <Progressbar
        style={
          {
            '--f7-progressbar-progress-color': chartColor,
          } as any
        }
        progress={percentageOfGoal * 100}
      />
      {progressLabel && (
        <div className="mt-1" style={{ fontSize: 12 }}>
          {progressLabel}
        </div>
      )}
    </div>
  );
};

interface ProgressCardProps extends MilestoneProgressProps {
  content: ReactNode;
  footer?: ReactNode;
}

export const ProgressCard: FC<ProgressCardProps> = ({
  milestones,
  currentValue,
  progressLabel,
  content,
  footer,
}) => {
  return (
    <Card>
      <div className="pt-3 pb-2 px-3">
        <div className="mb-2">
          <MilestoneProgress
            currentValue={currentValue}
            milestones={milestones}
            progressLabel={progressLabel}
          />
        </div>
        {content}
      </div>
      {footer && <Card.Footer>{footer}</Card.Footer>}
    </Card>
  );
};
